import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Column, GridContainer, Row, Typography } from '@vp/swan';
import { DebugModeContext } from '../../contexts/DebugModeContext';
import { InternalViewContext } from '../../contexts/InternalViewContext';
import { ActiveOrderControl } from '../../shared/internalView/ActiveOrderControl';
import { OrderDetailsApplication } from '../OrderDetailsApplication';

export const InternalViewOrderDetailsSession = ({ orderId }) => {
  const { debugEnabled, setDebugEnabled } = useContext(DebugModeContext);

  const { internalViewerSuppliedShopperId, internalViewSuppliedOrderId } =
    useContext(InternalViewContext);

  // Set the Debug Mode to enabled when in Internal View
  useEffect(() => {
    if (!debugEnabled) setDebugEnabled(true);
    // Ignoring exhaustive dependencies since we want to ensure this is set true only at component mount time.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showInternalViewOrderDetails =
    internalViewerSuppliedShopperId && internalViewSuppliedOrderId;

  return (
    <>
      <GridContainer>
        <Row mt={7} mb={3}>
          <Column span={12}>
            <Typography fontSize="x2large" textAlign="center">
              Welcome to Order Details Internal View
            </Typography>
          </Column>
        </Row>
        <Row mb={7}>
          <Column span={6} push={3}>
            <ActiveOrderControl defaultOrderId={orderId} />
          </Column>
        </Row>
      </GridContainer>
      {showInternalViewOrderDetails && (
        <OrderDetailsApplication
          shopperId={internalViewerSuppliedShopperId}
          orderId={internalViewSuppliedOrderId}
        />
      )}
    </>
  );
};

InternalViewOrderDetailsSession.propTypes = {
  orderId: PropTypes.string.isRequired,
};
